import React from 'react';

const ForgottenPasswordPage: React.FC = () => {
  return <>forgotten-password</>;
};

export default ForgottenPasswordPage;
